var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06081 1.56865C6.38091 0.69318 7.61908 0.693182 7.93918 1.56865L8.63377 3.4683C8.77794 3.86262 9.15307 4.12489 9.57292 4.1249L11.5453 4.12497C12.5423 4.125 12.9253 5.42419 12.0878 5.96503L10.7029 6.85937C10.3105 7.11276 10.1458 7.60404 10.3061 8.04275L10.8814 9.61642C11.2107 10.5173 10.2056 11.3202 9.39972 10.7998L7.54242 9.60064C7.21223 9.38744 6.78776 9.38744 6.45757 9.60064L4.60027 10.7998C3.79441 11.3202 2.7893 10.5173 3.11862 9.61642L3.69386 8.04275C3.85423 7.60405 3.68952 7.11276 3.29713 6.85937L1.91222 5.96503C1.07471 5.42419 1.45772 4.125 2.45468 4.12497L4.42707 4.1249C4.84692 4.12489 5.22205 3.86262 5.36622 3.4683L6.06081 1.56865Z",
    fill: "#FBF45C",
    stroke: "#CDC732"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon (1).becb71a890aab1b00bb171197ae93fd4.svg";
export { ForwardRef as ReactComponent };